import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router} from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { MapsAPILoader } from '@agm/core';
import { gutil } from '../gutil';
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-new-home',
  templateUrl: './new-home.component.html',
  styleUrls: ['./new-home.component.scss']
})
export class NewHomeComponent implements OnInit {

  public featuredPropertyBlr : Array<any>;
  public featuredPropertyPune : Array<any>;
  public featuredProperty : Array<any>;
  public selectedCity : String;
  public selectedType : Number;
  public featuredPropertyLoader : Boolean;
  public selectedTestimonialType : Number;
  public selectedLocation: any;
  public arrowRight = faLongArrowAltRight;
  public cityList : Array<any>;
  


  @ViewChild("search")
  public searchElementRef: ElementRef;

  @ViewChild("search_sm")
  public searchElementRef1: ElementRef;

  constructor(private router: Router, private http : HttpClient, private mapsAPILoader: MapsAPILoader) { }

  ngOnInit(): void {
    this.fetchFeaturedProperty();
    this.selectedCity = 'bengaluru';
    this.selectedType = 1;
    this.featuredPropertyLoader = false;
    this.selectedTestimonialType = 1;
    this.fetchAutoComplete(12.972442, 77.7032227);
    this.cityList = gutil.citySel;
  }

  //Change City
  public onSelectedCityChange(city: any) {
    
    
    if(city == 'bengaluru') {
      this.selectedCity = 'bengaluru';
      gutil.searchData.city = 'bengaluru';
      this.fetchAutoComplete(12.972442, 77.7032227);
    }
    else {
      this.selectedCity = 'pune';
      gutil.searchData.city = 'pune';
      this.fetchAutoComplete(18.5204, 73.8567);
    }    
    this.fetchFeaturedProperty();
  }

  public fetchFeaturedProperty(){
    this.featuredPropertyLoader = true;
    this.http.get(gutil.apiUrl + '/api/w/v1/get/featuredprop').subscribe((data: any) => {
        this.featuredPropertyBlr = data.data.bengaluru;
        this.featuredPropertyPune = data.data.pune;
        this.setFeaturedProperties(this.selectedCity , 1);
        // this.featuredPropertyLoader = false;
    })
    console.log(this.featuredPropertyLoader);
  }
  
  public setFeaturedProperties(city: String , type: Number){
    if(city === 'bengaluru' && type === 1){
      this.featuredProperty = this.featuredPropertyBlr.filter((item) => item.gender === 0);
    }
    if(city === 'bengaluru' && type === 2){
      this.featuredProperty = this.featuredPropertyBlr.filter((item) => item.gender === 1 || item.gender === 2);
    }
    if(city === 'pune' && type === 1){
      this.featuredProperty = this.featuredPropertyPune.filter((item) => item.gender === 0);
    }
    if(city === 'pune' && type === 2){
      this.featuredProperty = this.featuredPropertyPune.filter((item) => item.gender === 1 || item.gender === 2);
    }
    console.log(this.featuredProperty);
  }

  public toggleFeatureProperties(type: Number){
    this.selectedType = type;
    this.setFeaturedProperties(this.selectedCity , this.selectedType);
  }
  public slideScroll(element : any,direction: string,speed: number,distance: number,step: number){
    let scrollAmount = 0;
    let slideTimer = setInterval(function(){
      if(direction == 'left'){
        element.scrollLeft -= step;
      }else{
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if(scrollAmount >=distance ){
        window.clearInterval(slideTimer);
      }
    }, speed) 
  }
  public videoTestimonialRight(){
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'right',50,300,230);
  }
  public videoTestimonialLeft(){
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'left',50,300,230);
  }  
  public toggleTestimonials(type: Number){
    this.selectedTestimonialType = type;
  }

  //Google Autocomplete
  public fetchAutoComplete($lat:any,$lon:any){
    this.mapsAPILoader.load().then(() => {
      let defaultBounds: google.maps.LatLngBounds ;
      let options: google.maps.places.AutocompleteOptions;
      
        
      defaultBounds= new google.maps.LatLngBounds(
        new google.maps.LatLng($lat , $lon),
        new google.maps.LatLng($lat , $lon)
      );
      options = {
        bounds : defaultBounds,
        componentRestrictions : {country : 'in'}
      };
      
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement , options);
      autocomplete.addListener("place_changed", () => {
        this.selectedLocation = autocomplete.getPlace().formatted_address;
        
      })
      let autocomplete1 = new google.maps.places.Autocomplete(this.searchElementRef1.nativeElement , options);
      autocomplete1.addListener("place_changed", () => {
        this.selectedLocation = autocomplete1.getPlace().formatted_address;
        
      })
    })
  
   }

   public searchProperty() { 
    if(this.selectedLocation !== null && this.selectedLocation !== undefined){
      var loc = this.selectedLocation.substring(0 , this.selectedLocation.indexOf(",")).replace(" ",'-');
      var gender = 0;
      this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+ loc + '/' + gender ]).then(() => {})
    }else{
      alert("Please enter locality");
    }
  }

}
